module.exports = __webpack_public_path__ + "static/media/MobileDarkMode.8a3effec.png";